var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-toolbar",
        { attrs: { color: "yellow darken-4", dark: "", elevation: "0" } },
        [
          _c("span", [_vm._v("Edit Feed Detail")]),
          _c("v-spacer"),
          _c("v-icon", [_vm._v("mdi-alpha-d-box")])
        ],
        1
      ),
      _c(
        "v-container",
        { staticStyle: { "max-width": "800px" } },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { staticClass: "pb-0", attrs: { cols: "12" } },
                [
                  _c("small", { staticClass: "primary--text" }, [
                    _vm._v(_vm._s(_vm.stock.description || null))
                  ]),
                  _c("v-divider")
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "pb-0", attrs: { cols: "12" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: "Stock Code",
                      value: _vm.stockId,
                      readonly: "",
                      outlined: "",
                      dense: ""
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "py-0", attrs: { cols: "12" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      type: "number",
                      label: "Size"
                    },
                    model: {
                      value: _vm.size,
                      callback: function($$v) {
                        _vm.size = $$v
                      },
                      expression: "size"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "py-0", attrs: { lg: "6", cols: "12" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      type: "number",
                      label: "Cost / Bag"
                    },
                    model: {
                      value: _vm.perBag,
                      callback: function($$v) {
                        _vm.perBag = $$v
                      },
                      expression: "perBag"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "py-0", attrs: { lg: "6", cols: "12" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      type: "number",
                      label: "Cost / Kilo"
                    },
                    model: {
                      value: _vm.perKilo,
                      callback: function($$v) {
                        _vm.perKilo = $$v
                      },
                      expression: "perKilo"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "py-0", attrs: { lg: "6", cols: "12" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      type: "number",
                      label: "Resell / Bag"
                    },
                    model: {
                      value: _vm.resellPerBag,
                      callback: function($$v) {
                        _vm.resellPerBag = $$v
                      },
                      expression: "resellPerBag"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "py-0", attrs: { lg: "6", cols: "12" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      type: "number",
                      label: "Resell / Kilo"
                    },
                    model: {
                      value: _vm.resellPerKilo,
                      callback: function($$v) {
                        _vm.resellPerKilo = $$v
                      },
                      expression: "resellPerKilo"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "py-0", attrs: { cols: "12" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        block: "",
                        elevation: "0",
                        color: "primary",
                        dark: "",
                        loading: _vm.stockFdDtlPosting
                      },
                      on: { click: _vm.updateStockFdDtl }
                    },
                    [_c("span", [_vm._v("Save")])]
                  )
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "pb-0", attrs: { cols: "12" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        block: "",
                        elevation: "0",
                        color: "red",
                        dark: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.$router.push({
                            name: "stocks.feed-details.create"
                          })
                        }
                      }
                    },
                    [_c("span", [_vm._v("Cancel")])]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }